import { DeleteOutlineIcon } from '@carboncopyco/icons';
import { ConfirmAlert, TextBase } from '@carboncopyco/ui';

export interface WorkspaceArchiveModalProps {
  show: boolean;
  onClose: () => void;
  archiveWorkspace: () => void;
  label: string;
}

export const WorkspaceArchiveModal = ({
  show,
  onClose,
  archiveWorkspace,
  label,
}: WorkspaceArchiveModalProps) => {
  return (
    <ConfirmAlert
      title="Archive workspace"
      containerClass="w-ds-516"
      danger
      yesIcon={<DeleteOutlineIcon />}
      yesLabel="Archive and deactivate links"
      show={show}
      onConfirm={archiveWorkspace}
      onClose={onClose}
    >
      <div className="pt-3">
        <TextBase
          label={label}
          color="text-ds-natural-600"
        />
      </div>
    </ConfirmAlert>
  );
};
